// Новый скрипт для управления попапами с индивидуальными контейнерами и анимациями
// Требует GSAP и ScrollTrigger

(function () {
  // Регистрация ScrollTrigger
  if (
    window.gsap &&
    window.ScrollTrigger &&
    typeof window.gsap.registerPlugin === "function"
  ) {
    window.gsap.registerPlugin(window.ScrollTrigger);
  }

  const DARK_CLASS = "header-dark";
  const WHITE_ATTR = "data-menu-white";
  const HEADER_SELECTOR = ".header";
  const ANIM_DUR = 0.3;

  const header = document.querySelector(HEADER_SELECTOR);
  if (!header) return;

  // --- ОПРЕДЕЛЕНИЕ ДИНАМИКИ ТЕМЫ ПО ПУТИ ---
  const path = window.location.pathname.replace(/\/+$/, "");
  const isMenuThemeDynamic = path === "" || path.startsWith("/collections");

  // --- DARK CLASS CONTROL ---
  let popupForceDark = false;

  function addDark() {
    header.classList.add(DARK_CLASS);
  }
  function removeDark() {
    header.classList.remove(DARK_CLASS);
  }
  function setDarkByScroll() {
    if (!isMenuThemeDynamic) {
      return;
    }
    if (window.FORCE_MENU_DARK) {
      addDark();
      return;
    }
    if (popupForceDark) {
      return; // если открыт попап, не трогаем
    }
    if (window.scrollY > 0) {
      addDark();
    } else {
      removeDark();
    }
  }
  // При загрузке сразу выставить класс, если не на верху
  if (isMenuThemeDynamic) {
    window.addEventListener("DOMContentLoaded", setDarkByScroll);
    window.addEventListener("scroll", setDarkByScroll);
  } else {
    // если не динамика — всегда dark
    header.classList.add(DARK_CLASS);
  }

  // Высота меню
  function getMenuHeight() {
    const rem =
      parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return window.innerWidth > 991 ? 57 * rem : 40 * rem;
  }

  // ScrollTrigger для смены темы меню
  function initMenuThemeTriggers() {
    if (!isMenuThemeDynamic) {
      return;
    }
    if (window.FORCE_MENU_DARK) {
      addDark();
      return;
    }
    if (window.ScrollTrigger && ScrollTrigger.getAll) {
      ScrollTrigger.getAll()
        .filter((t) => t.vars && t.vars.id === "menu-theme-trigger")
        .forEach((t) => t.kill());
    }

    const whiteSections = Array.from(
      document.querySelectorAll(
        `section[${WHITE_ATTR}], main > *[${WHITE_ATTR}]`
      )
    );

    whiteSections.forEach((section) => {
      ScrollTrigger.create({
        id: "menu-theme-trigger",
        trigger: section,
        start: () => `top-=${getMenuHeight()} top`,
        end: () => `bottom top`,
        onEnter: () => {
          if (!popupForceDark) {
            removeDark();
          }
        },
        onEnterBack: () => {
          if (!popupForceDark) {
            removeDark();
          }
        },
        onLeave: () => {
          if (!popupForceDark) {
            addDark();
          }
        },
        onLeaveBack: () => {
          if (!popupForceDark) {
            addDark();
          }
        },
        invalidateOnRefresh: true,
      });
    });
  }

  // Универсальные функции блокировки скролла
  function blockScroll() {
    document.body.classList.add("no-scroll");
    document.body.style.overflow = "hidden";
  }
  function unblockScroll() {
    document.body.classList.remove("no-scroll");
    document.body.style.overflow = "";
  }

  // --- POPUP CORE ---
  // popupEl: .popup
  // wrapSel: .popup-wrap внутри popup
  // shadeSel: .shade внутри popup
  // openBtnSel: селектор кнопки открытия
  // closeBtnSels: массив селекторов внутри popup для закрытия
  // direction: 'y'|'x'|'none'
  // offset: сдвиг при анимации (px)
  function popupCore({
    popupEl,
    wrapSel = ".popup-wrap",
    shadeSel = ".shade",
    openBtnSel,
    closeBtnSels = [],
    direction = "y",
    offset = -40,
  }) {
    if (!popupEl) return;
    const wrap = popupEl.querySelector(wrapSel);
    const shade = popupEl.querySelector(shadeSel);
    const openBtn = openBtnSel ? document.querySelector(openBtnSel) : null;
    if (!wrap || !shade) return;

    let isOpen = false;
    let wrapTimeline = null;

    // Открытие
    function openPopup() {
      if (isOpen) return;
      isOpen = true;
      blockScroll();

      // popup: display block
      popupEl.style.display = "flex";
      // shade: display block, opacity 0→1
      shade.style.display = "block";
      gsap.set(shade, { opacity: 0 });
      gsap.to(shade, {
        opacity: 1,
        duration: ANIM_DUR,
        ease: "power2.out",
      });

      // wrap: display flex, opacity 0→1 + сдвиг
      wrap.style.display = "flex";
      let fromVars = { opacity: 0 };
      let toVars = { opacity: 1, duration: ANIM_DUR, ease: "power2.out" };
      if (direction === "y") {
        fromVars.y = offset;
        toVars.y = 0;
      } else if (direction === "x") {
        fromVars.x = offset;
        toVars.x = 0;
      }
      gsap.set(wrap, fromVars);
      wrapTimeline = gsap.timeline();
      wrapTimeline.to(wrap, toVars);

      // --- DARK CLASS ---
      popupForceDark = true;
      addDark();
    }

    // Закрытие
    function closePopup() {
      if (!isOpen) return;
      isOpen = false;
      unblockScroll();

      // wrap: opacity 1→0 + сдвиг, потом display none
      let toVars = {
        opacity: 0,
        duration: ANIM_DUR,
        ease: "power2.in",
        onComplete: () => {
          wrap.style.display = "none";
        },
      };
      if (direction === "y") {
        toVars.y = offset;
      } else if (direction === "x") {
        toVars.x = offset;
      }
      wrapTimeline = gsap.timeline();
      wrapTimeline.to(wrap, toVars);

      // shade: opacity 1→0, потом display none
      gsap.to(shade, {
        opacity: 0,
        duration: ANIM_DUR,
        ease: "power2.in",
        onComplete: () => {
          shade.style.display = "none";
        },
      });

      // popup: display none после анимаций
      setTimeout(() => {
        popupEl.style.display = "none";
      }, ANIM_DUR * 1000 + 20);

      // --- DARK CLASS ---
      popupForceDark = false;
      setDarkByScroll();
    }

    // Открытие по кнопке
    if (openBtn) {
      openBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (isOpen) {
          closePopup();
        } else {
          openPopup();
        }
      });
    }

    // Закрытие по shade
    shade.addEventListener("click", (e) => {
      console.log("[filter-popup] shade click", e);
      e.preventDefault();
      closePopup();
    });

    // Закрытие по кнопкам внутри попапа
    closeBtnSels.forEach((sel) => {
      const closeEl = popupEl.querySelector(sel);
      if (closeEl) {
        closeEl.addEventListener("click", (e) => {
          e.preventDefault();
          closePopup();
        });
      }
    });

    // ESC
    document.addEventListener("keydown", (e) => {
      if (isOpen && (e.key === "Escape" || e.key === "Esc")) {
        closePopup();
      }
    });

    // Возврат управления (можно вызвать вручную)
    return { open: openPopup, close: closePopup, isOpen: () => isOpen };
  }

  // --- Инициализация всех попапов ---
  function initAll() {
    initMenuThemeTriggers();

    // NAV DESKTOP
    popupCore({
      popupEl: document.querySelector(".popup.nav"),
      openBtnSel: ".header__shop",
      closeBtnSels: [],
      direction: "y",
      offset: -40,
    });

    // CART POPUP (аналогично filter-popup)
    (function () {
      const popup = document.querySelector(".popup.cart");
      const wrap = popup ? popup.querySelector(".popup-wrap") : null;
      const shade = popup ? popup.querySelector(".shade") : null;
      const btn = document.querySelector(".header__cart");
      if (!popup || !wrap || !shade) return;

      let isOpen = false;
      let wrapTimeline = null;

      function isMobile() {
        return window.innerWidth <= 991;
      }

      function openPopup() {
        if (isOpen) return;
        isOpen = true;
        blockScroll();
        popup.style.display = "flex";
        shade.style.display = "block";
        gsap.set(shade, { opacity: 0 });
        gsap.to(shade, {
          opacity: 1,
          duration: ANIM_DUR,
          ease: "power2.out",
        });
        wrap.style.display = "flex";
        if (isMobile()) {
          gsap.set(wrap, { y: -40, x: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            y: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        } else {
          gsap.set(wrap, { x: 40, y: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            x: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        }

        // --- DARK CLASS ---
        popupForceDark = true;
        addDark();
      }
      // Глобальная функция открытия корзины теперь всегда доступна
      window.openCartPopup = openPopup;

      function closePopup() {
        if (!isOpen) return;
        isOpen = false;
        unblockScroll();
        if (isMobile()) {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            y: -40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        } else {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            x: 40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        }
        gsap.to(shade, {
          opacity: 0,
          duration: ANIM_DUR,
          ease: "power2.in",
          onComplete: () => {
            shade.style.display = "none";
          },
        });

        // --- DARK CLASS ---
        popupForceDark = false;
        setDarkByScroll();
      }

      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          if (isOpen) {
            closePopup();
          } else {
            openPopup();
          }
        });
      }

      shade.addEventListener("click", (e) => {
        e.preventDefault();
        closePopup();
      });

      // Крестик
      const closeIc = popup.querySelector(".cart-popup__heading-ic");
      if (closeIc) {
        closeIc.addEventListener("click", (e) => {
          e.preventDefault();
          closePopup();
        });
      }

      document.addEventListener("keydown", (e) => {
        if (isOpen && (e.key === "Escape" || e.key === "Esc")) {
          closePopup();
        }
      });

      // Пересоздание на ресайзе
      window.addEventListener("resize", () => {
        isOpen = false;
        wrap.style.display = "none";
        popup.style.display = "none";
        shade.style.display = "none";
        shade.style.opacity = "";
        wrap.style.opacity = "";
        wrap.style.transform = "";
      });
    })();

    // DETAILS POPUP (аналогично cart popup)
    (function () {
      const popup = document.querySelector(".popup.details");
      const wrap = popup
        ? popup.querySelector(".popup-wrap.details-wrap")
        : null;
      const shade = popup ? popup.querySelector(".shade") : null;
      const btn = document.querySelector(".product-page__description-btn");
      if (!popup || !wrap || !shade || !btn) return;

      let isOpen = false;
      let wrapTimeline = null;

      function isMobile() {
        return window.innerWidth <= 991;
      }

      function openPopup() {
        if (isOpen) return;
        isOpen = true;
        blockScroll();
        popup.style.display = "flex";
        shade.style.display = "block";
        gsap.set(shade, { opacity: 0 });
        gsap.to(shade, {
          opacity: 1,
          duration: ANIM_DUR,
          ease: "power2.out",
        });
        wrap.style.display = "flex";
        if (isMobile()) {
          gsap.set(wrap, { y: -40, x: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            y: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        } else {
          gsap.set(wrap, { x: 40, y: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            x: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        }

        // --- DARK CLASS ---
        popupForceDark = true;
        addDark();
      }

      function closePopup() {
        if (!isOpen) return;
        isOpen = false;
        unblockScroll();
        if (isMobile()) {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            y: -40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        } else {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            x: 40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        }
        gsap.to(shade, {
          opacity: 0,
          duration: ANIM_DUR,
          ease: "power2.in",
          onComplete: () => {
            shade.style.display = "none";
          },
        });

        // --- DARK CLASS ---
        popupForceDark = false;
        setDarkByScroll();
      }

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (isOpen) {
          closePopup();
        } else {
          openPopup();
        }
      });

      shade.addEventListener("click", (e) => {
        e.preventDefault();
        closePopup();
      });

      // Крестик
      const closeIc = popup.querySelector(".details-popup__heading-ic");
      if (closeIc) {
        closeIc.addEventListener("click", (e) => {
          e.preventDefault();
          closePopup();
        });
      }

      document.addEventListener("keydown", (e) => {
        if (isOpen && (e.key === "Escape" || e.key === "Esc")) {
          closePopup();
        }
      });

      // Пересоздание на ресайзе
      window.addEventListener("resize", () => {
        isOpen = false;
        wrap.style.display = "none";
        popup.style.display = "none";
        shade.style.display = "none";
        shade.style.opacity = "";
        wrap.style.opacity = "";
        wrap.style.transform = "";
      });
    })();

    // GEAR POPUP (аналогично details popup)
    (function () {
      const popup = document.querySelector(".popup.gear");
      const wrap = popup ? popup.querySelector(".popup-wrap.gear-wrap") : null;
      const shade = popup ? popup.querySelector(".shade") : null;
      const cards = document.querySelectorAll(".home-gear__card");
      if (!popup || !wrap || !shade || !cards.length) return;

      let isOpen = false;
      let wrapTimeline = null;

      function isMobile() {
        return window.innerWidth <= 991;
      }

      function openPopup() {
        if (isOpen) return;
        isOpen = true;
        blockScroll();
        popup.style.display = "flex";
        shade.style.display = "block";
        gsap.set(shade, { opacity: 0 });
        gsap.to(shade, {
          opacity: 1,
          duration: ANIM_DUR,
          ease: "power2.out",
        });
        wrap.style.display = "flex";
        if (isMobile()) {
          gsap.set(wrap, { y: -40, x: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            y: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        } else {
          gsap.set(wrap, { x: 40, y: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            x: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        }

        popupForceDark = true;
        addDark();
      }

      function closePopup() {
        if (!isOpen) return;
        isOpen = false;
        unblockScroll();
        if (isMobile()) {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            y: -40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        } else {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            x: 40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        }
        gsap.to(shade, {
          opacity: 0,
          duration: ANIM_DUR,
          ease: "power2.in",
          onComplete: () => {
            shade.style.display = "none";
          },
        });

        popupForceDark = false;
        setDarkByScroll();
      }

      cards.forEach((card) => {
        card.addEventListener("click", (e) => {
          e.preventDefault();
          if (isOpen) {
            closePopup();
          } else {
            openPopup();
          }
        });
      });

      shade.addEventListener("click", (e) => {
        e.preventDefault();
        closePopup();
      });

      const closeIc = popup.querySelector(".gear-popup__heading-ic");
      if (closeIc) {
        closeIc.addEventListener("click", (e) => {
          e.preventDefault();
          closePopup();
        });
      }

      document.addEventListener("keydown", (e) => {
        if (isOpen && (e.key === "Escape" || e.key === "Esc")) {
          closePopup();
        }
      });

      window.addEventListener("resize", () => {
        isOpen = false;
        wrap.style.display = "none";
        popup.style.display = "none";
        shade.style.display = "none";
        shade.style.opacity = "";
        wrap.style.opacity = "";
        wrap.style.transform = "";
      });
    })();

    // SHIPPING POPUP (аналогично details popup)
    (function () {
      const popup = document.querySelector(".popup.shipping");
      const wrap = popup
        ? popup.querySelector(".popup-wrap.details-wrap")
        : null;
      const shade = popup ? popup.querySelector(".shade") : null;
      const btn = document.querySelector(".product-page__shipping-btn");
      if (!popup || !wrap || !shade || !btn) return;

      let isOpen = false;
      let wrapTimeline = null;

      function isMobile() {
        return window.innerWidth <= 991;
      }

      function openPopup() {
        if (isOpen) return;
        isOpen = true;
        blockScroll();
        popup.style.display = "flex";
        shade.style.display = "block";
        gsap.set(shade, { opacity: 0 });
        gsap.to(shade, {
          opacity: 1,
          duration: ANIM_DUR,
          ease: "power2.out",
        });
        wrap.style.display = "flex";
        if (isMobile()) {
          gsap.set(wrap, { y: -40, x: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            y: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        } else {
          gsap.set(wrap, { x: 40, y: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            x: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        }

        // --- DARK CLASS ---
        popupForceDark = true;
        addDark();
      }

      function closePopup() {
        if (!isOpen) return;
        isOpen = false;
        unblockScroll();
        if (isMobile()) {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            y: -40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        } else {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            x: 40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        }
        gsap.to(shade, {
          opacity: 0,
          duration: ANIM_DUR,
          ease: "power2.in",
          onComplete: () => {
            shade.style.display = "none";
          },
        });

        // --- DARK CLASS ---
        popupForceDark = false;
        setDarkByScroll();
      }

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (isOpen) {
          closePopup();
        } else {
          openPopup();
        }
      });

      shade.addEventListener("click", (e) => {
        e.preventDefault();
        closePopup();
      });

      // Крестик
      const closeIc = popup.querySelector(".details-popup__heading-ic");
      if (closeIc) {
        closeIc.addEventListener("click", (e) => {
          e.preventDefault();
          closePopup();
        });
      }

      document.addEventListener("keydown", (e) => {
        if (isOpen && (e.key === "Escape" || e.key === "Esc")) {
          closePopup();
        }
      });

      // Пересоздание на ресайзе
      window.addEventListener("resize", () => {
        isOpen = false;
        wrap.style.display = "none";
        popup.style.display = "none";
        shade.style.display = "none";
        shade.style.opacity = "";
        wrap.style.opacity = "";
        wrap.style.transform = "";
      });
    })();

    // NAV MOBILE
    (function () {
      const popup = document.querySelector(".popup.nav-mob");
      const wrap = popup ? popup.querySelector(".popup-wrap") : null;
      const shade = popup ? popup.querySelector(".shade") : null;
      const openBtn = document.querySelector(".header__burger-open");
      const closeBtn = document.querySelector(".header__burger-close");
      if (!popup || !wrap || !shade || !openBtn || !closeBtn) return;

      let isOpen = false;
      let wrapTimeline = null;

      function openPopup() {
        if (isOpen) return;
        isOpen = true;
        blockScroll();
        popup.style.display = "flex";
        shade.style.display = "block";
        gsap.set(shade, { opacity: 0 });
        gsap.to(shade, {
          opacity: 1,
          duration: ANIM_DUR,
          ease: "power2.out",
        });
        wrap.style.display = "flex";
        gsap.set(wrap, { y: -40, opacity: 0 });
        wrapTimeline = gsap.timeline();
        wrapTimeline.to(wrap, {
          y: 0,
          opacity: 1,
          duration: ANIM_DUR,
          ease: "power2.out",
        });
        openBtn.style.display = "none";
        closeBtn.style.display = "block";

        // --- DARK CLASS ---
        popupForceDark = true;
        addDark();
      }

      function closePopup() {
        if (!isOpen) return;
        isOpen = false;
        unblockScroll();
        wrapTimeline = gsap.timeline({
          onComplete: () => {
            wrap.style.display = "none";
            popup.style.display = "none";
            openBtn.style.display = "block";
            closeBtn.style.display = "none";
          },
        });
        wrapTimeline.to(wrap, {
          y: -40,
          opacity: 0,
          duration: ANIM_DUR,
          ease: "power2.in",
        });
        gsap.to(shade, {
          opacity: 0,
          duration: ANIM_DUR,
          ease: "power2.in",
          onComplete: () => {
            shade.style.display = "none";
          },
        });

        // --- DARK CLASS ---
        popupForceDark = false;
        setDarkByScroll();
      }

      openBtn.addEventListener("click", (e) => {
        e.preventDefault();
        openPopup();
      });
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        closePopup();
      });
      shade.addEventListener("click", (e) => {
        e.preventDefault();
        closePopup();
      });
      document.addEventListener("keydown", (e) => {
        if (isOpen && (e.key === "Escape" || e.key === "Esc")) {
          closePopup();
        }
      });

      // --- Дропдауны внутри nav-popup-mob ---
      const ddBlocks = wrap.querySelectorAll(".nav-popup-mob__dd");
      const ddStates = new Map();

      ddBlocks.forEach((dd) => {
        const title = dd.querySelector(".nav-popup-mob__dd-title");
        const mask = dd.querySelector(".nav-popup-mob__dd-mask");
        const iconOpen = dd.querySelector(".nav-popup-mob__dd-icon-open");
        const iconClose = dd.querySelector(".nav-popup-mob__dd-icon-close");

        ddStates.set(dd, { isDdOpen: false });

        function animateIcon(opening) {
          if (iconOpen && iconClose) {
            if (opening) {
              gsap.to(iconOpen, {
                opacity: 0,
                y: -8,
                duration: 0.18,
                pointerEvents: "none",
                onComplete: () => {
                  iconOpen.style.display = "none";
                  iconClose.style.display = "block";
                  gsap.fromTo(
                    iconClose,
                    { opacity: 0, y: 8 },
                    { opacity: 1, y: 0, duration: 0.18, pointerEvents: "auto" }
                  );
                },
              });
            } else {
              gsap.to(iconClose, {
                opacity: 0,
                y: 8,
                duration: 0.18,
                pointerEvents: "none",
                onComplete: () => {
                  iconClose.style.display = "none";
                  iconOpen.style.display = "block";
                  gsap.fromTo(
                    iconOpen,
                    { opacity: 0, y: -8 },
                    { opacity: 1, y: 0, duration: 0.18, pointerEvents: "auto" }
                  );
                },
              });
            }
          }
        }

        function openDropdown() {
          if (ddStates.get(dd).isDdOpen) return;
          ddBlocks.forEach((other) => {
            if (other !== dd) {
              other.classList.remove("active");
              const otherMask = other.querySelector(".nav-popup-mob__dd-mask");
              const otherIconOpen = other.querySelector(
                ".nav-popup-mob__dd-icon-open"
              );
              const otherIconClose = other.querySelector(
                ".nav-popup-mob__dd-icon-close"
              );
              ddStates.set(other, { isDdOpen: false });
              if (otherMask) {
                gsap.to(otherMask, {
                  height: 0,
                  opacity: 0,
                  duration: ANIM_DUR,
                  ease: "power2.in",
                  onComplete: () => {
                    otherMask.style.display = "none";
                  },
                });
              }
              if (otherIconOpen && otherIconClose) {
                gsap.set(otherIconOpen, { opacity: 1, y: 0 });
                otherIconOpen.style.display = "block";
                otherIconClose.style.display = "none";
                gsap.set(otherIconClose, { opacity: 0, y: 8 });
              }
              other.setAttribute("aria-expanded", "false");
            }
          });
          dd.classList.add("active");
          if (mask) {
            mask.style.display = "block";
            gsap.fromTo(
              mask,
              { height: 0, opacity: 0 },
              {
                height: mask.scrollHeight,
                opacity: 1,
                duration: ANIM_DUR,
                ease: "power2.out",
                onComplete: () => {
                  mask.style.height = "auto";
                },
              }
            );
          }
          animateIcon(true);
          dd.setAttribute("aria-expanded", "true");
          ddStates.set(dd, { isDdOpen: true });
        }

        function closeDropdown() {
          if (!ddStates.get(dd).isDdOpen) return;
          dd.classList.remove("active");
          if (mask) {
            gsap.to(mask, {
              height: 0,
              opacity: 0,
              duration: ANIM_DUR,
              ease: "power2.in",
              onComplete: () => {
                mask.style.display = "none";
              },
            });
          }
          animateIcon(false);
          dd.setAttribute("aria-expanded", "false");
          ddStates.set(dd, { isDdOpen: false });
        }

        title.addEventListener("click", (e) => {
          e.preventDefault();
          if (ddStates.get(dd).isDdOpen) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });
      });
    })();

    // FILTER POPUP
    (function () {
      const popup = document.querySelector(".popup.filter");
      const wrap = popup ? popup.querySelector(".popup-wrap") : null;
      const shade = popup ? popup.querySelector(".shade") : null;
      const btn = document.querySelector(".collection__filters-filter");
      if (!popup || !wrap || !shade) return;

      let isOpen = false;
      let wrapTimeline = null;

      function isMobile() {
        return window.innerWidth <= 991;
      }

      function openPopup() {
        if (isOpen) return;
        isOpen = true;
        blockScroll();
        popup.style.display = "flex";
        shade.style.display = "block";
        gsap.set(shade, { opacity: 0 });
        gsap.to(shade, {
          opacity: 1,
          duration: ANIM_DUR,
          ease: "power2.out",
        });
        wrap.style.display = "flex";
        if (isMobile()) {
          gsap.set(wrap, { y: -40, x: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            y: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        } else {
          gsap.set(wrap, { x: -40, y: 0, opacity: 0 });
          wrapTimeline = gsap.timeline();
          wrapTimeline.to(wrap, {
            x: 0,
            opacity: 1,
            duration: ANIM_DUR,
            ease: "power2.out",
          });
        }

        // --- DARK CLASS ---
        popupForceDark = true;
        addDark();
      }

      function closePopup() {
        if (!isOpen) return;
        isOpen = false;
        unblockScroll();
        if (isMobile()) {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            y: -40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        } else {
          wrapTimeline = gsap.timeline({
            onComplete: () => {
              wrap.style.display = "none";
              popup.style.display = "none";
            },
          });
          wrapTimeline.to(wrap, {
            x: -40,
            opacity: 0,
            duration: ANIM_DUR,
            ease: "power2.in",
          });
        }
        gsap.to(shade, {
          opacity: 0,
          duration: ANIM_DUR,
          ease: "power2.in",
          onComplete: () => {
            shade.style.display = "none";
          },
        });

        // --- DARK CLASS ---
        popupForceDark = false;
        setDarkByScroll();
      }

      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          if (isOpen) {
            closePopup();
          } else {
            openPopup();
          }
        });
      }

      shade.addEventListener("click", (e) => {
        e.preventDefault();
        closePopup();
      });

      // Крестик
      const closeIc = popup.querySelector(".filter-popup__heading-ic");
      if (closeIc) {
        closeIc.addEventListener("click", (e) => {
          e.preventDefault();
          closePopup();
        });
      }
      // Apply
      const applyBtn = popup.querySelector(".filter-popup__bot-apply");
      if (applyBtn) {
        applyBtn.addEventListener("click", (e) => {
          e.preventDefault();
          closePopup();
        });
      }

      // Reset (внутри фильтра)
      const filterResetBtns = popup.querySelectorAll(
        ".collection__filter-reset"
      );
      filterResetBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          const filter = btn.closest(".collection__filter");
          if (!filter) return;
          const checkboxes = filter.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach((cb) => {
            cb.checked = false;
            cb.dispatchEvent(new Event("change", { bubbles: true }));
          });
        });
      });

      // Reset all
      const resetAllBtn = popup.querySelector(".filter-popup__bot-reset");
      if (resetAllBtn) {
        resetAllBtn.addEventListener("click", (e) => {
          e.preventDefault();
          const allCheckboxes = popup.querySelectorAll(
            'input[type="checkbox"]'
          );
          allCheckboxes.forEach((cb) => {
            cb.checked = false;
            cb.dispatchEvent(new Event("change", { bubbles: true }));
          });
        });
      }

      document.addEventListener("keydown", (e) => {
        if (isOpen && (e.key === "Escape" || e.key === "Esc")) {
          closePopup();
        }
      });
    })();
  }

// Перезапуск при изменении ширины окна
let lastWidth = window.innerWidth;

window.addEventListener("resize", () => {
  const currentWidth = window.innerWidth;

  // Выполняем только если изменилась ширина (а не высота)
  if (currentWidth !== lastWidth) {
    lastWidth = currentWidth;

    // Закрыть все попапы при изменении ширины
    document.body.classList.remove("no-scroll");
    document.body.style.overflow = "";

    document.querySelectorAll(".popup").forEach((el) => {
      el.style.display = "none";
    });
    document.querySelectorAll(".shade").forEach((el) => {
      el.style.display = "none";
      el.style.opacity = "";
    });
    document.querySelectorAll(".popup-wrap").forEach((el) => {
      el.style.display = "none";
      el.style.opacity = "";
      el.style.transform = "";
    });

    // Обновить ScrollTrigger и тему меню
    if (isMenuThemeDynamic && window.ScrollTrigger) {
      ScrollTrigger.refresh();
      setDarkByScroll();
    }
  }
});


  window.addEventListener("DOMContentLoaded", function () {
    initAll();
  });
  window.addEventListener("shopify:section:load", function () {
    initAll();
  });
})();
